export enum PageLocaleEnum {
  FRENCH = 'fr',
  ENGLISH = 'en',
  SPANISH = 'es',
  ITALIAN = 'it',
  PORTUGUESE = 'pt',
  DEUTSCH = 'de',
  DUTCH = 'nl',
  RUSSIAN = 'ru',
  JAPANESE = 'jp',
  ARABIC = 'ar',
  TURKISH = 'tr',
  CHINESE = 'zh',
  SWEDISH = 'sv',
  ROMANIAN = 'ro',
  CZECH = 'cs',
  HUNGARIAN = 'hu',
  SLOVAK = 'sk',
  DANISH = 'dk',
  INDONESIAN = 'id',
  POLISH = 'pl',
  GREEK = 'el',
  SERBIAN = 'sr',
  NORWEGIAN = 'no',
  THAI = 'th',
  SLOVENIAN = 'sl',
  UKRAINIAN = 'ua',
  ALBANIA = 'sq',
  HINDI = 'hi',
}

export const PageLocaleNames: Record<PageLocaleEnum, string> = {
  [PageLocaleEnum.ENGLISH]: 'English',
  [PageLocaleEnum.FRENCH]: 'Français',
  [PageLocaleEnum.SPANISH]: 'Español',
  [PageLocaleEnum.ITALIAN]: 'Italiano',
  [PageLocaleEnum.PORTUGUESE]: 'Português',
  [PageLocaleEnum.DEUTSCH]: 'Deutsch',
  [PageLocaleEnum.DUTCH]: 'Nederlands',
  [PageLocaleEnum.RUSSIAN]: 'Русский',
  [PageLocaleEnum.JAPANESE]: '日本語',
  [PageLocaleEnum.ARABIC]: 'عربي',
  [PageLocaleEnum.TURKISH]: 'Türkçe',
  [PageLocaleEnum.CHINESE]: '中國人',
  [PageLocaleEnum.SWEDISH]: 'Svenska',
  [PageLocaleEnum.ROMANIAN]: 'Română',
  [PageLocaleEnum.CZECH]: 'Čeština',
  [PageLocaleEnum.HUNGARIAN]: 'Magyar',
  [PageLocaleEnum.SLOVAK]: 'Slovenský',
  [PageLocaleEnum.DANISH]: 'Dansk',
  [PageLocaleEnum.INDONESIAN]: 'Indonesian',
  [PageLocaleEnum.POLISH]: 'Polski',
  [PageLocaleEnum.GREEK]: 'Ελληνικά',
  [PageLocaleEnum.SERBIAN]: 'Srpski',
  [PageLocaleEnum.HINDI]: 'Hindi',
  [PageLocaleEnum.NORWEGIAN]: 'Norsk',
  [PageLocaleEnum.THAI]: 'ไทย',
  [PageLocaleEnum.SLOVENIAN]: 'Slovenski',
  [PageLocaleEnum.UKRAINIAN]: 'Український',
  [PageLocaleEnum.ALBANIA]: 'Shqiptare',
}
